<template>
  <div class="variantsList">
    <template class="variantItem" v-for="item in reOrderDatas" :key="item.code">
      <VariantItem :data="item" />
    </template>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, watchEffect } from 'vue'
import VariantItem from '@/components/shop/VariantItem.vue'
import _ from 'lodash'

export default {
  name: 'variantsList',
  emits: ['change'],
  components: {
    VariantItem
  },
  props: {
    datas: {
      type: Array,
      default: () => []
    },
    isEWProduct: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const state = reactive({ reOrderDatas: [] })
    watchEffect(() => {
      state.reOrderDatas = props.isEWProduct
        ? props.datas.map(item => {
            const values = _.filter(item.values, value => !value.disable)
            if (item.name === '服务内容' || item.code === 'salesAttributeServiceContent') {
              if (values.length > 1) {
                const originalValues = JSON.parse(JSON.stringify(values))
                const primateValue = _.find(values, ele => {
                  const hasName = ele.code.includes('整车')
                  if (hasName) {
                    _.remove(originalValues, value => value.code === ele.code)
                  }
                  return hasName
                })
                const reOrderServiceContentValues = primateValue ? [primateValue, ...originalValues] : values
                return {
                  ...item,
                  values: reOrderServiceContentValues
                }
              } else {
                return { ...item, values }
              }
            } else {
              return { ...item, values }
            }
          })
        : props.datas
    })
    onMounted(() => {
      // console.log('SETSELECTSHOPVARIANTITEM---onMounted')
    })
    return {
      ...toRefs(state)
    }
  }
}
</script>

<style lang="scss" scoped></style>
